import { render, staticRenderFns } from "./EdicionCertificadosBase.vue?vue&type=template&id=7d3c2bb4&"
import script from "./EdicionCertificadosBase.vue?vue&type=script&lang=ts&"
export * from "./EdicionCertificadosBase.vue?vue&type=script&lang=ts&"
import style0 from "./EdicionCertificadosBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports